import { render, staticRenderFns } from "./landingTab.vue?vue&type=template&id=ec28c98c&scoped=true&"
import script from "./landingTab.vue?vue&type=script&lang=js&"
export * from "./landingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec28c98c",
  null
  
)

export default component.exports